import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { openRequestModal } from '../actions/modals';
import Types from '../constants/user';
import NewsService from '../services/news.service';

const NewsInitializer = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { info, emulation } = useSelector(state => state.user);
    const role_id = emulation.length ? emulation[emulation.length - 1].info?.role_id : info?.role_id;

    const prevBasePath = useRef('');

    const showNewsQueue = newsList => {
        if (!newsList.length) return;
        const [current, ...rest] = newsList;

        dispatch(
            openRequestModal({
                opened: true,
                data: {
                    id: current.id,
                    header: t('news.news'),
                    modaltype: 'ViewNews',
                    isQueued: true,
                    queue: rest,
                },
            })
        );
    };

    const getNewNews = async () => {
        try {
            const res = await NewsService.GetNewNews();
            if (Array.isArray(res) && res.length > 0) {
                showNewsQueue(res);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        (async () => {
            try {
                const res = await NewsService.GetUnviewedNews();
                dispatch({
                    type: Types.SET_PERMISSIONS_DATA,
                    payload: {
                        news: Array.isArray(res) ? res.length : 0,
                    },
                });
            } catch (error) {
                console.error(error);
            }
        })();
    }, []);

    useEffect(() => {
        const basePath = location.pathname.split('/')[1] || '';

        if (prevBasePath.current === basePath) {
            return;
        }

        prevBasePath.current = basePath;

        if ([3, 4].includes(role_id)) {
            getNewNews();
        }
    }, [location.pathname, role_id]);

    return null;
};

export default NewsInitializer;
